import Header from "../header";
import { Topics } from "../topics";

const Home = () => {
  return (
    <div className='snap-y snap-mandatory'>
      <Header />
      <Topics />
    </div>
  );
};

export default Home;
